module.exports = __webpack_public_path__ + "static/img/console2.dba4652.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_images/console2.gif
// module id = Tb7X
// module chunks = 39